<template>
  <UIHeading
    level="3"
    variant="default"
    class="p-0 text-[15px] font-semibold tracking-[-0.01em] text-app-black"
    data-test-id="title"
  >
    <slot />
  </UIHeading>
</template>

<script lang="ts" setup>
import UIHeading from '../ui-heading/UIHeading.vue';
</script>

<style scoped lang="scss"></style>
